import React from "react";

export default function SQL_DEFAULT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_DEFAULT</h1>
      <p>This is the SQL_DEFAULT component generated from the SQL JSON.</p>
    </div>
  );
}
